const PageLoader = () => {
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center">
      {/* Mystical orb with glow effect */}
      <div className="relative mb-8">
        {/* Outer glow ring */}
        <div 
          className="absolute inset-0 w-20 h-20 rounded-full border-2 border-primary/20 animate-spin"
          style={{ animationDuration: '4s' }}
        />
        
        {/* Middle pulsing ring */}
        <div 
          className="absolute inset-2 w-16 h-16 rounded-full border border-primary/30 animate-spin"
          style={{ animationDuration: '3s', animationDirection: 'reverse' }}
        />
        
        {/* Inner glowing orb */}
        <div className="w-20 h-20 rounded-full bg-gradient-to-br from-primary/20 via-primary/10 to-transparent flex items-center justify-center">
          <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary/40 to-primary/20 animate-pulse shadow-[0_0_30px_rgba(139,92,246,0.3)]" />
        </div>
        
        {/* Sparkle dots */}
        <div 
          className="absolute -top-1 right-2 w-2 h-2 bg-primary/60 rounded-full animate-ping"
          style={{ animationDuration: '1.5s' }}
        />
        <div 
          className="absolute bottom-0 -left-1 w-1.5 h-1.5 bg-primary/50 rounded-full animate-ping"
          style={{ animationDuration: '2s', animationDelay: '0.5s' }}
        />
        <div 
          className="absolute top-1/2 -right-2 w-1 h-1 bg-primary/40 rounded-full animate-ping"
          style={{ animationDuration: '1.8s', animationDelay: '0.3s' }}
        />
      </div>
      
      {/* Brand text */}
      <h1 className="font-yusei text-2xl text-foreground/80 mb-3">
        ✨ Askyourtarot
      </h1>
      <p className="text-sm text-muted-foreground animate-pulse">
        Connecting to the stars...
      </p>
    </div>
  );
};

export { PageLoader };
